import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import { report_deposit } from "../components/Report.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      amount: "0.00",
      amount_deposit: "0.00",
      discount: "0.00",
      total_pay: "0.00",
      transaction_list: [],
      warehouse: "",
      is_delivery: false
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("uid")) {
      await this.Get(params("uid"));
    }
    // window.print();
  }
  Get = async (uid) => {
    loading(true);
    let result = await GET("admin/sales/list", { uid });
    if (result?.status) {
      const item = result.data;
      const data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer?.full_name,
        customer_phone: item.customer?.phone,
        transaction_list: item.transaction_list || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        discount: item.discount,
        total_pay: item.total_pay,
        warehouse: item.warehouse?.name || "",
        is_delivery: item.is_delivery
      }
      this.setState(data);
      await report_deposit(data);
      setTimeout(() => {
        
    window.close();
      }, 200);
    }
    loading(false);
  };
  render() {
    const {
      document_no,
      created_at,
      customer_name,
      customer_phone,
      transaction_list,
      amount,
      amount_deposit,
      discount,
      total_pay,
      warehouse,
      is_delivery
    } = this.state;
    return (
      <div></div>
//       <div className="mx-auto bg-white p-5 pdf" style={{ width: 446 }}>
//         <h5 className="fw-bold text-center mb-2">ใบมัดจำสินค้า({warehouse})</h5>
//         <h5 className="fw-bold text-center mb-3">
//           ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)
//         </h5>
//         <div className="fw-bold text-center text-14 mb-3">
//           โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060
//         </div>
//         <div className="text-16">
//           <div className="row mb-3">
//             <div className="col-6 mb-2">
//               <div className="w-100 fw-bold">เลขที่ : {document_no}</div>
//             </div>
//             <div className="col-6 mb-2">
//               <div className="w-100 fw-bold">
//                 วันที่ : {format_date(created_at, "dd mmmm yyyy")}
//               </div>
//             </div>

//             <div className="col-6 mb-2">
//               <div className="w-100 fw-bold">ลูกค้า : {customer_name}</div>
//             </div>
//             <div className="col-6 mb-2">
//               <div className="w-100 fw-bold">โทร : {customer_phone}</div>
//             </div>
//           </div>
//           <hr />
//           {transaction_list?.map((item, index) => (
//             <div className="mb-4" style={{fontSize:18}}>
//               <div>{item.product_name} {item.remark ? `(${item.remark})` : ""}</div>
//               {item.serial_number && <div>No.{item.serial_number}</div>}
//               <div className="d-flex justify-content-between">
//                 <div>
//                   {item.qty} x {toFixed(item.unit_price)}
//                 </div>
//                 <div>{toFixed((Number(item.qty) * Number(item.unit_price))-Number(item.discount))} ฿</div>
//               </div>
//             </div>
//           ))}
//           <hr />
//           <div className="d-flex justify-content-between fw-bold mb-2" style={{fontSize:18}}>
//             <div>รวมทั้งหมด ( {total(transaction_list, "qty")} รายการ )</div>
//             <div>{toFixed(amount)} ฿</div>
//           </div>

//                     <div className="d-flex justify-content-between fw-bold mb-2" style={{fontSize:18}}>
//                       <div>ส่วนลด</div>
//                       <div>{toFixed(Number(discount) + total(transaction_list,"discount"))} ฿</div>
//                     </div>
//           <div className="d-flex justify-content-between fw-bold mb-2" style={{fontSize:18}}>
//             <div>มัดจำ</div>
//             <div>{toFixed(amount_deposit)} ฿</div>
//           </div>
//           <div className="d-flex justify-content-between fw-bold mb-2" style={{fontSize:18}}>
//             <div>คงค้าง</div>
//             <div>
//               {toFixed(
//                 Number(amount) - Number(amount_deposit) - (Number(discount) + total(transaction_list,"discount"))
//               )}{" "}
//               ฿
//             </div>
//           </div>
//           <div className="fw-bold mb-2" style={{fontSize:18}}>
//             <div>*ราคานี้ไม่รวมภาษีมูลค่าเพิ่ม</div>
//           </div>
//           {is_delivery && (
//   <div className="fw-bold mb-2" style={{fontSize:18}}>
//             <div>ส่งปลายทาง</div>
//           </div>
// )}
//         </div>
//         <hr />
//         <h5 className="fw-bold mb-4" style={{ lineHeight: 2 }}>
//           หมายเหตุ : ให้มารับสินค้าภายใน...............วัน
//           พ้นกำหนดถือว่าสละสิทธิ์ (สินค้าทุกชนิดมัดจำแล้ว
//           <br />
//           ไม่รับคืน)
//         </h5>
//         <h5 className="fw-bold mt-5 mb-4">
//           ลงชื่อ.....................................................ผู้มัดจำ
//         </h5>
//         <h5 className="fw-bold mb-4">
//           (......................................................................)
//         </h5>
//       </div>
    );
  }
}
